import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_orbit = _resolveComponent("q-spinner-orbit")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createBlock(_component_q_inner_loading, {
    showing: _ctx.loading,
    class: _normalizeClass(_ctx.$q.dark.isActive ? "bg-dark" : "bg-white")
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_spinner_orbit, _mergeProps({ size: "3em" }, _ctx.$attrs, {
        color: _ctx.$q.dark.isActive ? "white" : "primary",
        thickness: 2
      }), null, 16, ["color"])
    ]),
    _: 1
  }, 8, ["showing", "class"]))
}